import Resource from './Resource'
import { commonCaseReportServices } from '@/api/resources/common/commonCaseReportServices/commonCaseReportServices'

class PatientResource extends Resource {
    constructor() {
        super()
        this.source = null
    }
    cancelAxiosCall() {
        if (this.source) {
            this.source.cancel()
            this.source = null
        }
    }
    async paginator(params) {
        const response = await this.axios.get('/patients/search', { params })
        return response.data
    }

    async paginatorMultiSourced(params) {
        this.source = this.axios.CancelToken.source()
        const response = await this.axios.get('/patients/multiSourcedSearch', { params, cancelToken: this.source.token })
        return response.data
    }

    async create(data) {
        return this.axios.post(`/patients`, data).then(response => response.data)
    }

    async edit(patId, data) {
        return this.axios.put(`/patients/${patId}`, data).then(response => response.data)
    }

    async delete(patId) {
        return this.axios.delete(`/patients/${patId}`)
    }

    async findById(patId) {
        const response = await this.axios.get(`/patients/${patId}`)
        return response.data
    }

    async checkDuplicate(patientIdentifier) {
        return this.axios.get(`/patients/patientIdentifiers/checkDuplicate`, { params: patientIdentifier }).then(response => response.data)
    }

    async getPreviousCaseAPReport(laboratoryId, patId, print) {
        const params = {
            encoded: print,
            laboratoryId: laboratoryId,
            patientId: patId
        }
        const responseType = print ? null : 'arraybuffer'
        const type = 'application/pdf'
        const headers = {
            responseType,
            type
        }
        return commonCaseReportServices.getPreviousAPRPatient(params, headers)
    }
}

export default new PatientResource()
